"use client";

import React, { useState, useEffect } from "react";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { upperFirst } from "lodash";
import useTranslation from "translations/hooks/useTranslation";

const components = {
  facebook: {
    Button: FacebookShareButton,
    Icon: FacebookIcon,
  },
  twitter: {
    Button: TwitterShareButton,
    Icon: TwitterIcon,
  },
  whatsapp: {
    Button: WhatsappShareButton,
    Icon: WhatsappIcon,
  },
};

function ShareSocial(props) {
  const { t } = useTranslation();

  const [isCopied, setIsCopied] = useState(false);
  const [iconSize, setIconSize] = useState(40);
  const {
    title,
    socialTypes = ["facebook", "twitter"],
    articleId,
    onSocialButtonClicked = () => {},
    lang
  } = props;

  useEffect(() => {
    const updateIconSize = () => {
      setIconSize(window.innerWidth < 640 ? 32 : 40);
    };

    updateIconSize();
    window.addEventListener('resize', updateIconSize);
    return () => window.removeEventListener('resize', updateIconSize);
  }, []);


  const shareUrl = `${process?.env?.NEXT_PUBLIC_WEBSITE_URL}/${lang}/news/n/${articleId}`
  const copyToClipboard = (text) => {
    if (navigator && navigator.clipboard)
      navigator.clipboard
        .writeText(text)
        .then(() => {
          setIsCopied(true);
          // Reset copied state after 3 seconds
          setTimeout(() => {
            setIsCopied(false);
          }, 3000);
        })
        .catch((error) => {
          alert(`Copy failed! ${error}`);
        });
  };

  function getComponent(type) {
    const { Button, Icon } = components[type];
    const buttonProps = {
      url: shareUrl, // Use the generated share URL
      onClick: () => onSocialButtonClicked(type),
      windowWidth: 650,
      windowHeight: 500,
      // Make sure links open in new tab
      openShareDialogOnClick: true,
      ...(type === "facebook" && title ? { quote: title } : {}),
    };

    return (
      <Button {...buttonProps}>
        <Icon size={iconSize} round />
      </Button>
    );
  }

  return (
    <div
      className="relative bg-white h-auto pt-6 md:pb-4 flex flex-col items-center w-full max-w-md mx-auto px-4 sm:px-6 lg:max-w-lg"
      data-testid="root"
    >
     <div
        className="w-full p-1 md:p-2 border border-gray-300 bg-lightGrey flex text-sm sm:text-base items-center rounded-lg  flex-row justify-between"
      >
        <div
          className="text-[#0C66FF] cursor-pointer flex items-center justify-center flex-shrink-0"
          data-testid="copy-btn"
          onClick={() => copyToClipboard(shareUrl)} 
        >
          <p
            className="mb-0 px-2 py-1 text-xs sm:text-sm font-medium hover:bg-blue-50 rounded transition-colors"
          >
            {isCopied ? t('copied') :   t('copy')}
          </p>
        </div>
        <div
          className="text-disabled overflow-hidden text-xs sm:text-sm leading-5 text-ellipsis px-2 flex-1 text-right sm:text-left min-w-0 whitespace-nowrap"
          style={{ direction: "ltr" }}
          data-testid="url"
        >
          {shareUrl}
        </div>
      </div>
      <div
        className="py-2 md:py-4 flex justify-center items-center gap-3 sm:gap-4 flex-wrap"
      >
        {Array?.isArray(socialTypes) &&
          socialTypes?.map((type, idx) => {
            return (
              <div
                title={upperFirst(type || "")}
                className="cursor-pointer transform hover:scale-105 transition-transform duration-200"
                key={"social_item_" + idx}
              >
                {getComponent(type)}
              </div>
            );
          })}
      </div>
    </div>
  );
}

export { ShareSocial };
